/**
 * Database entity types shared between frontend and backend.
 * These types match the Drizzle schema but exclude internal fields.
 */
/** All badge preset keys, in display order. */
export const BADGE_STYLE_KEYS = [
    'farm',
    'housing',
    'school',
    'volunteer',
    'general',
];
//# sourceMappingURL=db.js.map